import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import Vatlist from "./vatlist";
import styles from "../Settings.module.scss";
import EditVat from "./Editvat";
import { toast } from "react-toastify";
import { addVat } from "../../../services/vatService";

const Vatcodes = (props) => {
  const [isFormOpen, setIsFormOpen] = React.useState(false);

  const handleOpenForm = () => {
    setIsFormOpen(true);
    props.open?.();
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  const handleSubmit = async (formData) => {
    try {
      await addVat(formData);
      toast.success("VAT Added");
      handleCloseForm();
    } catch (error) {
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className="d-flex ms-auto mb-3 flex-shrink-0">
        <Button
          className={`common-btn setting-btn`}
          onClick={handleOpenForm}
        >
          Add VAT
        </Button>
      </div>

      <div className="flex-grow-1  mb-2" style={{ minHeight: 0 }}>
        <Vatlist />
      </div>

      {isFormOpen && (
        <EditVat
          cancelEdit={handleCloseForm}
          type="addNew"
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default Vatcodes;
